import React from "react";
import "./css/App.css";
import Landing from "./pages/landing";

const App = () => {
  return <Landing />;
};

export default App;
